import { getStorefrontUrlFromSlug } from '@/app/buy/seller/[sellerSlug]/getStorefrontUrl'

/**
 * The storefront pages the bundled hero banners link to.
 *
 * Kept out of the client hook so the server can check them against the hidden storefronts and send
 * the browser only which of these few are hidden, never the whole hidden list.
 */
export const BUNDLED_BANNER_STOREFRONT_LINKS = {
  amazon: getStorefrontUrlFromSlug('amazon'),
  costco: getStorefrontUrlFromSlug('costco'),
} as const
